import { useContext } from 'react';
import UiContext from '../../../lib/UiContext';
const ProgramInfoInfoHeader = ({
  ChildComponent
}) => {
  const uiContext = useContext(UiContext);
  const queryParams = {
    id: uiContext.entity.id,
    startDate: uiContext.dateSpan.from.format('YYYY-MM-DD'),
    endDate: uiContext.dateSpan.to.format('YYYY-MM-DD')
  };
  const menu = [{
    key: 'overview',
    title: 'Overview',
    link: {
      pathname: `/reports/program/overview`,
      query: queryParams
    }
  }, {
    key: 'leaderboards',
    title: 'Leaderboard',
    children: [{
      key: 'districts',
      title: 'Districts',
      link: {
        pathname: `/reports/program/leaderboards`,
        query: {
          ...queryParams,
          view: `districts`
        }
      }
    }, {
      key: 'schools',
      title: 'Schools',
      link: {
        pathname: `/reports/program/leaderboards`,
        query: {
          ...queryParams,
          view: `schools`
        }
      }
    }, {
      key: 'classes',
      title: 'Classes',
      link: {
        pathname: `/reports/program/leaderboards`,
        query: {
          ...queryParams,
          view: `classes`
        }
      }
    }, {
      key: 'students',
      title: 'Students',
      link: {
        pathname: `/reports/program/leaderboards`,
        query: {
          ...queryParams,
          view: `students`
        }
      }
    }]
  }, {
    key: 'proficiency',
    title: 'Proficiency',
    link: {
      pathname: `/reports/program/proficiency`,
      query: queryParams
    }
  }, {
    key: 'growth',
    title: 'Growth',
    link: {
      pathname: `/reports/program/growth`,
      query: queryParams
    }
  }, {
    key: 'progress',
    title: 'Progress',
    link: {
      pathname: `/reports/program/progress`,
      query: queryParams
    }
  }, uiContext.entity.hasMic && {
    key: 'community',
    title: 'Community Summary',
    link: {
      pathname: `/reports/program/community`,
      query: queryParams
    }
  }].filter(Boolean);
  const title = <>
      Program: {uiContext.entity.name}
    </>;
  const props = {
    menu,
    title
  };
  return <ChildComponent {...props} data-sentry-element="ChildComponent" data-sentry-component="ProgramInfoInfoHeader" data-sentry-source-file="ProgramGroup.jsx" />;
};
export default ProgramInfoInfoHeader;